import { useEffect, useState } from "react";

import Marquii from "../../components/Marquii.js";
import NavbarTop from "../../components/Navbars.js";

import headimg from "../../assets/images/header.png"

import "../pages/header.css";

const Header = ({ APPDATA, routes }) => {
  const hideThis = (e) => {
    e.target.parentElement.parentElement.style.display = 'none';
  };

  const [spinUp, setSpinUp] = useState(0);
  useEffect(() => {
    setSpinUp("Waiting for connections... (Spin up)"); // while db connect etc..
    setSpinUp(0);
    return () => { };
  }, []);

  return (
    <>
      <div className="header-container">
        <img src={headimg} alt="headimg"></img>
        <NavbarTop
          APPDATA={APPDATA}
          routes={routes}
        // currentUser={currentUser}
        />
      </div>

      {APPDATA.MODE.substring(0, 4).toUpperCase() !== "PROD" ? (
        <Marquii
          title="Change MODE in process.env"
          id="marquii-dev"
          overlay={<></>}>
          <div onClick={hideThis} aria-hidden>
            App is in {APPDATA.MODE.toUpperCase()} Mode (this will not show in PROD mode) (Ver: {APPDATA.VERSION}) &emsp; - Click or Touch to dismiss this</div>
        </Marquii>
      ) : null}

      {/* {spinUp ? <Marquii>{spinUp}</Marquii> : null} */}

      {spinUp ? <>{spinUp}</> : null}
    </>
  );
};

export default Header;
